<template>
  <div class="wrapper-content w-100">
    <h1>{{title}}</h1>
    <LmComponentLoading v-if="isLoading" fixed />
    <LmBreadcrumb v-if="showBreadcrumb" />
    <h5>Para el Trámite: {{tramiteNumber}}</h5>
    <h5>Oficina: {{nombreOficina}}</h5>
    <LmForm ref="lmFormRef">
      <div class="row">
        <LmSuperPowerSelect
          class="col-12 col-lg-8"
          :data="lmSuperPowerSelects.oficina.selectOptions"
          :tbColumns="lmSuperPowerSelects.oficina.tbColumns"
          label="Asignar a"
          title="Asignar a"
          placeholder="Seleccione"
          @values="actualizarUsuarioAsignado"
          :v="$v.form.nombre"
        />
        <LmTextArea
          class="col-12 col-lg-8"
          v-model="form.mensaje"
          :v="$v.form.mensaje"
          label="Mensaje"
          placeholder="Detalle de la asignacion"
          />
      </div>
      <LmButton
        id="btn-cancel"
        type="button"
        buttonClass="btn-secondary"
        :isProcessing="formIsProcessing"
        :value="$t('Cancel')"
        @click.native="cancelBtn"
        lmButtonRootWrapperClass="d-inline-block mr-1"
        lmButtonWrapperClass="col"
        />
      <LmButton
        id="btn-submit"
        type="submit"
        buttonClass="btn-primary"
        :isProcessing="formIsProcessing"
        :value="$t('Save')"
        lmButtonRootWrapperClass="d-inline-block"
        lmButtonWrapperClass="col"
        @click.native="submit"
        />
    </LmForm>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import LmForm from '@/components/form/LmForm.vue'
import LmTextArea from '@/components/form/elements/LmTextArea'
import LmButton from '@/components/form/elements/LmButton'
import LmSuperPowerSelect from '@/components/form/elements/LmSuperPowerSelect.vue'
import lmSuperPowerSelectHelper from '@/mixins/LmSuperPowerSelectHelper.js'
import lmToasts from '@/mixins/lmToasts.js'
import LmComponentLoading from '@/components/LmComponentLoading'

export default {
  mixins: [lmSuperPowerSelectHelper, lmToasts],
  components: {
    LmForm,
    LmButton,
    LmTextArea,
    LmSuperPowerSelect,
    LmComponentLoading
  },
  data () {
    return {
      showBreadcrumb: process.env.VUE_APP_SHOWBREADCRUMB === 'yes',
      lmSuperPowerSelects: {
        oficina: {
          selectOptions: [],
          tbColumns: [
            { title: 'id', data: 'id' },
            { title: 'Usuario', data: 'name' }
          ]
        }
      },
      tramiteNumber: '',
      nombreOficina: '',
      form: {
        nombre: '',
        mensaje: ''
      },
      isLoading: true,
      formIsProcessing: false
    }
  },
  props: {
    id: {
      type: String,
      required: false
    },
    title: {
      type: String,
      required: true
    },
    // La uri tanto para obtener la configuracion desde settings como
    // para interactuar con el endpoint que obtiene y persiste los datos
    // para la edicion
    newEndpointUri: {
      type: String,
      required: true
    },
    onSuccessDestinationRoute: {
      type: String,
      required: true
    }
  },
  validations: {
    form: {
      nombre: {
        required
      },
      mensaje: {
        required
      }
    }
  },
  methods: {
    ...mapActions('commons', ['updateItemDetail']),
    cancelBtn () {
      this.$router.go(-1)
    },
    async submit () {
      try {
        await this.$refs.lmFormRef.validationForm(this.$v)
        this.formIsProcessing = true
        /**
         * Se persisten los datos
         */
        const saveData = {
          id: this.$route.params.id,
          legajo: this.form.legajo,
          mensaje: this.form.mensaje
        }
        try {
          await this.updateItemDetail({
            path: this.newEndpointUri,
            data: saveData
          })
          this.formIsProcessing = false
          this.lmToastSuccessMessage(`Se registró un nuevo pase interno para '${this.form.nombre}'`, `Pase Interno para ${this.tramiteNumber}`)
          // this.$router.replace(`${this.onSuccessDestinationRoute}/${this.$route.params.id}`)
          this.$router.go(-1)
        } catch (error) {
          this.formIsProcessing = false
        }
      } catch (error) {
        console.log('error', error)
      }
    },
    actualizarUsuarioAsignado (values) {
      const isThereValue = values.length
      const value = values[0]
      this.form.legajo = isThereValue ? value.id : ''
      this.form.nombre = isThereValue ? value.name : ''
    }
  },
  mounted () {
    const insertAttributes = {
      validate: true,
      id: this.$route.params.id
    }
    this.updateItemDetail({
      path: this.newEndpointUri,
      data: insertAttributes
    })
      .then(r => {
        this.isLoading = false
        this.tramiteNumber = r.tramiteNumber ? r.tramiteNumber : ''
        this.nombreOficina = r.nombreOficina ? r.nombreOficina : ''
      })
      .catch(error => {
        console.log(error)
        this.$router.replace({ name: '401' })
      })
  },
  created () {
    (async () => {
      const allLmSuperPowerSelectOptions = await this.getAllLmSuperPowerSelectOptions([
        {
          name: 'oficina',
          obj: {
            path: 'usuarios/poroficina/',
            total: 1000
          }
        }
      ])
      allLmSuperPowerSelectOptions.forEach(async element => {
        const e = await element
        this.lmSuperPowerSelects[e.name].selectOptions = e.data
      })
    })()
  }
}
</script>

<style lang="sass" scoped>
  h5
    margin-bottom: 30px !important
</style>
